
import VerRegistros from "../../components/admin/VerRegistros.vue";
import ModificarDispositivos from "../../components/admin/ModificarDispositivos.vue";
import vhero from "../../components/shared/VHero.vue";
import Vue from "vue";

export default Vue.extend({
  components: { vhero, ModificarDispositivos, VerRegistros },
  mounted() {
    this.cargarDatos();
  },
  data() {
    return {
      usuarios: "",
      modalDispositivos: {
        active: false,
        userId: ""
      },
      modalRegistros: {
        active: false,
        userId: ""
      },
      esCargado: false
    };
  },
  methods: {
    activar(id: string) {
      const datos = {
        id,
        email: ""
      };

      this.$http
        .put("Usuario/activar", datos, {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`
          }
        })
        .then(() => {
          this.$toast.open({
            message: "Activada correctamente",
            type: "is-success",
            position: "is-bottom"
          });

          this.cargarDatos();
        })
        .catch(() => {
          this.$toast.open({
            message: "Error al activar",
            type: "is-danger",
            position: "is-bottom"
          });
        });
    },
    desactivar(id: string) {
      const datos = {
        id,
        email: ""
      };

      this.$http
        .put("Usuario/desactivar", datos, {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`
          }
        })
        .then(() => {
          this.$toast.open({
            message: "Desactivada correctamente",
            type: "is-success",
            position: "is-bottom"
          });

          this.cargarDatos();
        })
        .catch(() => {
          this.$toast.open({
            message: "Error al desactivar",
            type: "is-danger",
            position: "is-bottom"
          });
        });
    },
    cargarDatos() {
      this.$http
        .get("Usuario", {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`
          }
        })
        .then(res => {
          this.usuarios = res.data.usuariosDatos;
          this.esCargado = true;
        })
        .catch(() => {
          this.$router.push("/");
          this.esCargado = true;
        });
    },
    descargarExcel(){
      this.$http.get("Informe",{
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      }).then(res => {
          const d = new Date()
          const formatDate = d.getDate() +"-"+ d.getMonth()  + "-"+ d.getFullYear() + "-" + d.getHours() + "-" + d.getMinutes() 
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'informe-completo_'+formatDate+'.xlsx');
          link.click();
      })
    }
  }
});
